// FOR REVIEW - review this whole file and all it's endpoints
// src/store.js
import {
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";
import { axiosInstance } from "services/axios-supabase";
import _ from "lodash";
import moment from "moment";

// ------------------------------------------------------------------------
// Initial state
const initialState = {
  report: [],
  loading: false,
  error: null,
  reportLoaded: false,
};

export const selectQuickReportLoaded = (state) =>
  state.quickReportReducer.reportLoaded;

export const fetchQuickReport = createAsyncThunk(
  "data/fetchQuickReport",
  async (params = {}, { rejectWithValue }) => {
    try {
      if (!params.date) params.date = moment().format("YYYY-MM-DD");
      const response = await axiosInstance.get("/calendar/reports/quick", {
        params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const QuickReportSlice = createSlice({
  name: "data",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuickReport.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchQuickReport.fulfilled, (state, action) => {
        state.loading = false;
        state.report = action.payload;
        state.reportLoaded = true;
      });
  },
});

// Export actions and reducers
export const { setLoading, setError } = QuickReportSlice.actions;

export default QuickReportSlice.reducer;
